// extracted by mini-css-extract-plugin
export default {"wrapper":"ProtectedGroupsLayout_wrapper__x7XXo","groupPageWrapper":"ProtectedGroupsLayout_groupPageWrapper__aTbhX"};